/* global isAdyenZppBancontactIntegrationEnabled */

const BANCONTACT_ADYEN_CREDIT_CARD = {};
const isEditPaymentPage = window.location.href.includes('editpayment');

BANCONTACT_ADYEN_CREDIT_CARD.init = function () {
  if (isEditPaymentPage && isAdyenZppBancontactIntegrationEnabled) {
    initializeZppAdyenForm();
  }
};

const initializeZppAdyenForm = () => {
  if (window.Payment && window.Payment.renderBancontactAdyenManageCreditCards) {
    window.Payment.renderBancontactAdyenManageCreditCards();
  }
};

export default BANCONTACT_ADYEN_CREDIT_CARD;
